import { ProductOwnerType } from '../../../../../../../../graphql/order/models/get-orders.models';
import { DependentLenses } from '../../../../../../../../graphql/lenses/models/get-lenses.models';
import { ProfileData } from '../../../../../profile-label';

export const getDependentProfile = (
  getDependentColorIndex: Function,
  dependent?: DependentLenses,
): ProfileData => dependent ? {
  firstName: dependent.firstName,
  lastName: dependent.lastName,
  isActive: dependent.active,
  colorIndex: dependent?.firstName && dependent?.lastName
    ? getDependentColorIndex(dependent.firstName, dependent.lastName)
    : undefined,
  ownerType: ProductOwnerType.dependent,
} : {
  firstName: '',
  lastName: '',
  isActive: true,
  colorIndex: undefined,
  ownerType: ProductOwnerType.consumer,
};
